import React, { Component } from 'react';
/** Personal */
import { getDom } from '../NormalStem';

class Stem extends Component {
    render() {
        const { stem } = this.props;

        return (
            <div>
                {
                    stem.map((para, i) => {
                        return <div className={para.style} key={i}>
                            {
                                para.style === 'math_category' ?
                                    <StemCategory options={para.children[0]} /> :
                                    para.children.map((child, i) => getDom(child, i))
                            }
                        </div>
                    })
                }
            </div>
        )
    }
}

class StemCategory extends Component {
    render() {
        const { options } = this.props;

        return (
            <div className='category-stem-list'>
                {
                    options.drag.map(item =>
                        <div className='category-stem-item' key={item.id}>
                            <span className='category-stem-name'>{item.content}</span>
                            <span className='category-stem-box'></span>
                        </div>
                    )
                }
            </div>
        )
    }
}

class ItemList extends Component {
    render() {
        const { item_list } = this.props;

        return (
            <div className="category-list">
                {
                    item_list.map(item =>
                        item.item.map((val, i) =>
                            <span className='category-item' key={i}>
                                {getDom(val, i)}
                            </span>
                        )
                    )
                }
            </div>
        )
    }
}

class StemItem extends Component {
    render() {
        const { list, className } = this.props;

        return (
            <p className={className}>
                {
                    list.map((item, i) => getDom(item, i))
                }
            </p>
        )
    }
}

const Option = (props) => {
    return <span className='category-item'>
        {
            props.option.map((o, i) => getDom(o, i))
        }
    </span>
};

export default Stem;
export { StemItem, ItemList, Option };


// WEBPACK FOOTER //
// ./src/entry_question_editor/question/exercise/classify/Stem.js